import { UpdateStamp } from "./UpdateStamp";

export class PaperPermit extends UpdateStamp
{
  PaperPermitId : number;
//This is used to store paper permit filename.
 FileName : string;
//This is used to store paper permit url where it would be uploaded.
 FileOriginalUrl : string;
//This is foreign key reference from Permit table.
 PermitId : number;
 
//This is used to store paper permit file size.
 FileSize : number;

}